.chunkyImage {
  composes: -chunkyImage from "./util.module.css";
}
